/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilityModel } from '../../models/availability-model';
import { CalendarEntryRequestModel } from '../../models/calendar-entry-request-model';

export interface HealthFindrAvailibilityPost$Params {
      body?: CalendarEntryRequestModel
}

export function healthFindrAvailibilityPost(http: HttpClient, rootUrl: string, params?: HealthFindrAvailibilityPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<AvailabilityModel>> {
  const rb = new RequestBuilder(rootUrl, healthFindrAvailibilityPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<AvailabilityModel>;
    })
  );
}

healthFindrAvailibilityPost.PATH = '/HealthFindr/Availibility';
